import React from "react";

export default function SilenceOverviewPageIt() {
  return (
    <div
      style={{
        maxWidth: 700,
        margin: "48px auto",
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 2px 12px #0001",
        padding: 36,
        fontFamily: "inherit",
        color: "#222",
      }}
    >
      <h2 style={{ fontSize: 42, fontWeight: 900, color: "#006b44", margin: 0 }}>
        Monitoraggio dei silenzi
      </h2>

      <p style={{ margin: "12px 0", lineHeight: 1.5 }}>
        Dimentica gli “stacchi” imprevisti in onda. Il nostro servizio{" "}
        <b>monitora i tuoi stream radio (MP3 e AAC+) 24/7</b>{" "}
        e ti avvisa immediatamente in caso di silenzio.
      </p>

      <ul style={{ paddingLeft: 18, margin: "14px 0" }}>
        <li style={{ marginBottom: 8 }}>
          Le notifiche arrivano <b>su Telegram</b> subito dopo il rilevamento del problema.
        </li>
        <li style={{ marginBottom: 8 }}>
          Puoi aggiungere <b>2 contatti aggiuntivi</b>{" "}
          (ad es. team tecnico o di programmazione) — già inclusi nel prezzo.
        </li>
        <li style={{ marginBottom: 8 }}>
          È disponibile una <b>cronologia di 7 giorni dei livelli di volume</b>{" "}
          per ogni stream, con precisione al secondo — vedrai sempre cosa è successo in onda.
        </li>
      </ul>

      <p style={{ margin: "12px 0", lineHeight: 1.5 }}>
        Collegamento semplice, nessun hardware aggiuntivo. La tua messa in onda è sotto controllo.
      </p>
    </div>
  );
}
